import { css } from '@emotion/react'
import styled from '@emotion/styled'
import profileSymbol from '../../../assets/icons/profile.svg'
import { circleButtonStyle } from './Button.styles' // Updated import
import theme from '../../../styles/theme'

const AvatarIconStyle = css`
  ${circleButtonStyle}
  background-image: url(${profileSymbol});
  background-size: 40%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${`${theme.colors.secondLight}A0`};
`

export const AvatarIcon = styled.img`
  border-radius: 100%;
  width: 2.4rem !important;
  height: 2.4rem !important;
`

export default AvatarIconStyle
